module.exports = __webpack_public_path__ + "static/media/13-3.c10effdb.mp3";